import React, { useState, useEffect } from 'react';
import axios from 'axios';

const OnetNoAuthTest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const testApi = async () => {
      setLoading(true);
      console.log('Testing O*NET API without authentication...');
      
      try {
        // Test direct O*NET API call without authentication
        const response = await axios.get('https://services.onetcenter.org/ws/mnm/search', {
          params: {
            keyword: 'software',
            limit: 3
          }
        });
        console.log('Direct O*NET result:', response.data);
        setResult({ success: true, data: response.data });
      } catch (error) {
        console.error('Direct O*NET API Test Error:', error);
        setResult({ success: false, error: error.message, status: error.response?.status });
      } finally {
        setLoading(false);
      }
    };

    testApi();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>O*NET API Test (No Authentication)</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Test Details:</h3>
        <p><strong>URL:</strong> https://services.onetcenter.org/ws/mnm/search</p>
        <p><strong>Method:</strong> Direct API call (no proxy, no auth)</p>
        <p><strong>Purpose:</strong> Test if O*NET API works without authentication</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Test Status:</h3>
        {loading && <p>🔄 Testing O*NET API...</p>}
        {result && (
          <div style={{ 
            padding: '10px', 
            backgroundColor: result.success ? '#d4edda' : '#f8d7da',
            color: result.success ? '#155724' : '#721c24',
            border: `1px solid ${result.success ? '#c3e6cb' : '#f5c6cb'}`,
            borderRadius: '5px'
          }}>
            <p><strong>Status:</strong> {result.success ? '✅ Success' : '❌ Failed'}</p>
            {result.error && <p><strong>Error:</strong> {result.error}</p>}
            {result.status && <p><strong>HTTP Status:</strong> {result.status}</p>}
            {result.data && <p><strong>Data received:</strong> {JSON.stringify(result.data).substring(0, 200)}...</p>}
          </div>
        )}
      </div>

      <div style={{ 
        padding: '10px', 
        backgroundColor: '#fff3cd', 
        color: '#856404',
        border: '1px solid #ffeaa7',
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h4>Note:</h4>
        <p>This test bypasses our proxy and authentication to see if the O*NET API works at all. If this fails with CORS, we know the issue is with our setup. If it works, we know the issue is with authentication.</p>
      </div>

      <div style={{ 
        padding: '10px', 
        backgroundColor: '#e0e0e0', 
        borderRadius: '5px',
        fontSize: '12px'
      }}>
        <h4>Console Logs:</h4>
        <p>Check the browser console for detailed API request/response logs.</p>
      </div>
    </div>
  );
};

export default OnetNoAuthTest;
